import React from "react";
import "./discard-warning-modal.scss";
import { Modal, Typography } from "antd";

const { Title, Text } = Typography;

const DiscardWarningModal = ({ visible, onOk, onCancel }) => {
  return (
    <Modal
      className="discard-warning-modal"
      title={null}
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      okText="Proceed"
      cancelText="Cancel"
      centered
      style={{ textAlign: "center", padding: "16px 16px 32px 16px" }}
    >
      <div className="discard-modal-body">
        <Title
          level={5}
          style={{
            fontWeight: 500,
            fontSize: "18px",
            lineHeight: "150%",
            letterSpacing: 0,
            margin: 0,
          }}
        >
          Discard Uploaded OCR Data?
        </Title>
        <Text type="secondary">
          If you proceed, all uploaded documents and their extracted OCR data
          will be discarded.
        </Text>
      </div>
    </Modal>
  );
};

export default DiscardWarningModal;
